import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AdviserItem, TinkTankItem } from "../model/AboutModel";
import { DetailsModel } from "../model/HomeModel";
import { AboutServices, HomeServices } from "../service/Service";

export interface AboutState {
  adviserList: AdviserItem[];
  adviserItem: AdviserItem | null;
  adviserModel: boolean;

  tinkTankList: TinkTankItem[];
  tinkTankItem: TinkTankItem | null;
  tinkTankModel: boolean;
}

const initialState: AboutState = {
  adviserList: [],
  adviserItem: null,
  adviserModel: false,

  tinkTankList: [],
  tinkTankItem: null,
  tinkTankModel: false,
};

export const detailsAsync = createAsyncThunk(
  "details/getDetailsData",
  async ({
    url,
    uuid,
    methods,
  }: {
    url: string;
    uuid: string;
    methods: "get" | "post";
  }) => {
    console.log('🚀', url);
    console.log('🚀', uuid);
    console.log('🚀', methods);
    const response = await HomeServices.details({ uuid, url, methods });
    return response.data as DetailsModel;
  }
);

export const adviserAsync = createAsyncThunk(
  "about/getAdviserData",
  async () => {
    const response = await AboutServices.adviser();
    return response.data;
  }
);

export const tinkTankAsync = createAsyncThunk(
  "about/getTinkTankData",
  async () => {
    const response = await AboutServices.tinkTank();
    return response.data;
  }
);

export const AboutStore = createSlice({
  name: "about",
  initialState,
  reducers: {
    setAdviserItem: (state, action: PayloadAction<AdviserItem | null>) => {
      state.adviserItem = action.payload;
      state.adviserModel = true;
    },
    setAdviserModel: (state, action: PayloadAction<boolean>) => {
      state.adviserModel = action.payload;
    },
    setTinkTankItem: (state, action: PayloadAction<TinkTankItem | null>) => {
      state.tinkTankItem = action.payload;
      state.tinkTankModel = true;
    },
    setTinkTankModel: (state, action: PayloadAction<boolean>) => {
      state.tinkTankModel = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(adviserAsync.fulfilled, (state, actions) => {
      const arr: AdviserItem[] = [];

      if (actions.payload && actions.payload.adviser) {
        for (const item of actions.payload.adviser) {
          for (const value of item) {
            arr.push(value);
          }
        }
      }

      state.adviserList = arr;
    });

    // builder.addCase(tinkTankAsync.fulfilled, (state, actions) => {
    //   const arr: TinkTankItem[] = [];

    //   if (actions.payload && actions.payload.member) {
    //     for (const item of actions.payload.member) {
    //       arr.push(item);
    //       // for (const value of item) {
    //       //   arr.push(value);
    //       // }
    //     }
    //   }

    //   state.tinkTankList = arr;
    // });
    builder.addCase(tinkTankAsync.fulfilled, (state, actions) => {
      state.tinkTankList = (actions.payload && actions.payload.member) || [];
    });
  },
});

export const { setAdviserItem, setAdviserModel, setTinkTankItem, setTinkTankModel } = AboutStore.actions;

export default AboutStore.reducer;
